<nav class="glass-navbar">
  <div class="nav-container">
    <!-- Logo -->
    <a routerLink="/" class="logo-section">
      <div class="logo-circle">
        <mat-icon class="!text-white">security</mat-icon>
      </div>
      <span class="logo-text">UTP Technology</span>
    </a>

    <!-- Desktop Navigation (Center/Main) -->
    <div class="desktop-menu">
      <a routerLink="/productos" routerLinkActive="active" class="nav-link">Productos</a>
      <a routerLink="/pedidos" routerLinkActive="active" class="nav-link" *ngIf="isLogged">Mis Pedidos</a>
      <a routerLink="/carrito-compras" routerLinkActive="active" class="nav-link">Carrito</a>
      <a routerLink="/admin/productos" routerLinkActive="active" class="nav-link" *ngIf="isAdmin">Dashboard</a>
      <a routerLink="/admin/usuarios" routerLinkActive="active" class="nav-link text-purple-400" *ngIf="user?.id_rol === 1">Usuarios</a>
    </div>

    <!-- User Actions / Profile -->
    <div class="user-actions">
      <!-- Desktop User Info -->
      <ng-container *ngIf="isLogged; else loginBtn">
        <button [matMenuTriggerFor]="menu" class="user-profile-btn desktop-menu">
          <mat-icon>account_circle</mat-icon>
          <span>{{ user?.nombre | slice:0:10 }}{{ (user?.nombre?.length || 0) > 10 ? '...' : '' }}</span>
        </button>
      </ng-container>

      <ng-template #loginBtn>
        <a routerLink="/login" class="user-profile-btn desktop-menu">
          <mat-icon>login</mat-icon>
          <span>Ingresar</span>
        </a>
      </ng-template>

      <!-- Mobile Toggle -->
      <button mat-icon-button [matMenuTriggerFor]="menu" class="mobile-toggle">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  </div>
</nav>

<!-- Unified Menu (Mobile Sidebar and User Profile) -->
<mat-menu #menu="matMenu" class="glass-effect">
  <!-- In mobile, show all links -->
  <div class="sm:hidden">
    <button mat-menu-item routerLink="/productos">
      <mat-icon>shopping_bag</mat-icon>
      <span>Productos</span>
    </button>
    <button mat-menu-item routerLink="/pedidos" *ngIf="isLogged">
      <mat-icon>receipt_long</mat-icon>
      <span>Mis Pedidos</span>
    </button>
    <button mat-menu-item routerLink="/carrito-compras">
      <mat-icon>shopping_cart</mat-icon>
      <span>Carrito</span>
    </button>
    <button mat-menu-item routerLink="/admin/productos" *ngIf="isAdmin">
      <mat-icon>dashboard</mat-icon>
      <span>Dashboard</span>
    </button>
    <button mat-menu-item routerLink="/admin/usuarios" *ngIf="user?.id_rol === 1" class="!text-purple-400">
      <mat-icon class="!text-purple-400">manage_accounts</mat-icon>
      <span>Usuarios</span>
    </button>
    <hr class="border-white/10 my-1 mx-2">
  </div>

  <!-- Common User Actions -->
  <ng-container *ngIf="isLogged; else loginMenu">
    <button mat-menu-item disabled class="!opacity-100 !text-blue-400 !font-bold">
      <mat-icon class="!text-blue-400">person</mat-icon>
      <span>{{ user?.nombre }}</span>
    </button>
    <button mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Cerrar Sesión</span>
    </button>
  </ng-container>

  <ng-template #loginMenu>
    <button mat-menu-item routerLink="/login">
      <mat-icon>login</mat-icon>
      <span>Ingresar</span>
    </button>
  </ng-template>
</mat-menu>
